import styled from 'styled-components';

export const StepContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: flex-start;
  padding-top: 40px;
`;

export const ContentCard = styled.div`
	width: 100%;
	max-width: 400px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
`;

export const TitleSection = styled.div`
  margin-top: -50px;
	margin-bottom: 28px;

	h2 {
		margin-bottom: 12px;
	}

	p {
		margin: 0;
		max-width: 360px;
		margin: 0 auto;
		line-height: 1.5;
		color: ${({ theme }) => theme.secondaryText || '#6b7280'};
	}
`;

export const TitleWrapper = styled.div`
	margin-bottom: 8px;
`;

export const DescriptionWrapper = styled.div`
	max-width: 400px;
	margin: 0 auto;

	p {
		margin: 0;
		color: ${({ theme }) => theme.secondaryText || '#6b7280'};
		line-height: 1.4;
	}
`;

export const PlanCard = styled.div`
	width: 100%;
	background: #ffffff;
	border: 2px solid #7b7b7b;
	border-radius: 18px;
	padding: 28px 24px;
	text-align: left;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
	margin-bottom: 32px;
`;

export const PlanTitle = styled.div`
	margin-bottom: 16px;

	h4 {
		margin: 0;
		font-size: 24px;
		font-weight: 700;
    color: #000000
	}
`;

export const FeatureList = styled.ul`
	margin: 0 0 22px 0;
	padding-left: 18px;
`;

export const FeatureItem = styled.li`
	margin-bottom: 14px;

	p {
		margin: 0;
		color: ${({ theme }) => theme.secondaryText || '#6b7280'};
		line-height: 1.5;
	}
`;

export const PriceRow = styled.div`
  margin-top: 12px;
  margin-bottom: 6px;

	h3 {
		margin: 0;
		font-size: 26px;
		font-weight: 700;
    color: #000000
	}
`;

export const SubText = styled.div`
  margin-top: 6px;

	p {
		margin: 0;
		font-size: 13px;
		color: ${({ theme }) => theme.secondaryText || '#535965'};
	}
`;

export const ButtonGroup = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-top: 8px;
`;

export const PaymentLink = styled.button`
	width: 100%;
	height: 44px;
  
  border: none;
	border-radius: 999px;
	background: #2563eb;
	color: #ffffff;
	font-weight: 600;
  font-size: 16px;

  cursor: pointer;
  	transition: all 0.2s ease;

	&:hover {
		filter: brightness(1.05);
		transform: translateY(-1px);
	}

	display: flex;
	align-items: center;
	justify-content: center;
  margin-bottom: 64px;
`;
